import { call, put, takeEvery } from "@redux-saga/core/effects";
import { ADD_NEW_NOTIFICATION } from "Actions/ConfigAction";
import {
  START_GET_HOME_LIST,
  SUCCESS_GET_HOME_LIST,
  ERROR_GET_HOME_LIST,
  START_GET_NO_OF_ALERT,
  SUCCESS_GET_NO_OF_ALERT,
  ERROR_GET_NO_OF_ALERT,
  START_CHASEUP_CHART,
  SUCCESS_CHASEUP_CHART,
  ERROR_CHASEUP_CHART,
  START_ORDER_CHART,
  SUCCESS_ORDER_CHART,
  ERROR_ORDER_CHART,
  START_PAYMENT_CREATE,
  SUCCESS_PAYMENT_CREATE,
  ERROR_PAYMENT_CREATE,
  SUCCESS_PAYMENT_LINK,
  ERROR_PAYMENT_LINK,
  START_PAYMENT_LINK,
  SUCCESS_PAYMENT_LIST,
  ERROR_PAYMENT_LIST,
  START_PAYMENT_LIST,
  SUCCESS_SUBSCRIPTION_CREATE,
  ERROR_SUBSCRIPTION_CREATE,
  START_SUBSCRIPTION_CREATE,
  SUCCESS_SUBSCRIPTION_CANCEL,
  ERROR_SUBSCRIPTION_CANCEL,
  START_SUBSCRIPTION_CANCEL,
  START_SUBSCRIPTION_UPDATE,
  SUCCESS_SUBSCRIPTION_UPDATE,
  ERROR_SUBSCRIPTION_UPDATE,
} from "Actions/HomeAction";
import {
  ERROR_ORDER_SPEED,
  START_ORDER_SPEED,
  SUCCESS_ORDER_SPEED,
} from "Actions/OrderPadAction";
import {
  getChaseUpChart,
  getHomeListAPI,
  getNoOfAlertAPI,
  getOrderChart,
  getPaymentCreate,
  getPaymentLinkCreate,
  getPaymentList,
  getSubscriptionCancle,
  getSubscriptionCreate,
  getSubscriptionUpdate,
  getorderSpeed,
} from "Api/HomeApis";

function* getHomeCountListWorker({ payload }) {
  try {
    const res = yield call(getHomeListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_HOME_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_HOME_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}

function* getNoOfAlert({ payload }) {
  try {
    const res = yield call(getNoOfAlertAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_NO_OF_ALERT,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_NO_OF_ALERT,
        payload: res,
      });
    }
  } catch (error) {}
}

function* getOrderSpeed({ payload }) {
  try {
    const res = yield call(getorderSpeed, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_ORDER_SPEED,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_ORDER_SPEED,
        payload: res,
      });
    }
  } catch (error) {}
}
function* getchaseUpChart({ payload }) {
  try {
    const res = yield call(getChaseUpChart, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_CHASEUP_CHART,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_CHASEUP_CHART,
        payload: res,
      });
    }
  } catch (error) {}
}
function* getorderChart({ payload }) {
  try {
    const res = yield call(getOrderChart, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_ORDER_CHART,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_ORDER_CHART,
        payload: res,
      });
    }
  } catch (error) {}
}
function* getPayment({ payload }) {
  try {
    const res = yield call(getPaymentCreate, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_PAYMENT_CREATE,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Your payment successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_PAYMENT_CREATE,
        payload: res,
      });
    }
  } catch (error) {}
}

function* getPaymentLink({ payload }) {
  try {
    const res = yield call(getPaymentLinkCreate, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_PAYMENT_LINK,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Your payment list generate successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_PAYMENT_LINK,
        payload: res,
      });
    }
  } catch (error) {}
}
function* getPaymentListMain({ payload }) {
  try {
    const res = yield call(getPaymentList, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_PAYMENT_LIST,
        payload: res,
      });
      // yield put({
      //   type: ADD_NEW_NOTIFICATION,
      //   payload: {
      //     message: "Your payment list generate successfully",
      //     type: "success",
      //   },
      // });
    } else {
      yield put({
        type: ERROR_PAYMENT_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}
function* getSubscription({ payload }) {
  try {
    const res = yield call(getSubscriptionCreate, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_SUBSCRIPTION_CREATE,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Your card loaded successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_SUBSCRIPTION_CREATE,
        payload: res,
      });
    }
  } catch (error) {}
}
function* getSubscriptionCancleMain({ payload }) {
  try {
    const res = yield call(getSubscriptionCancle, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_SUBSCRIPTION_CANCEL,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Your subscrition cancelled successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_SUBSCRIPTION_CANCEL,
        payload: res,
      });
    }
  } catch (error) {}
}
function* getSubscriptionUpdateMain({ payload }) {
  try {
    const res = yield call(getSubscriptionUpdate, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_SUBSCRIPTION_UPDATE,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Your payment updated successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_SUBSCRIPTION_UPDATE,
        payload: res,
      });
    }
  } catch (error) {}
}

export function* HomeSaga() {
  yield takeEvery(START_GET_HOME_LIST, getHomeCountListWorker);
  yield takeEvery(START_GET_NO_OF_ALERT, getNoOfAlert);
  yield takeEvery(START_ORDER_SPEED, getOrderSpeed);
  yield takeEvery(START_CHASEUP_CHART, getchaseUpChart);
  yield takeEvery(START_ORDER_CHART, getorderChart);
  yield takeEvery(START_PAYMENT_CREATE, getPayment);
  yield takeEvery(START_PAYMENT_LINK, getPaymentLink);
  yield takeEvery(START_PAYMENT_LIST, getPaymentListMain);
  yield takeEvery(START_SUBSCRIPTION_CREATE, getSubscription);
  yield takeEvery(START_SUBSCRIPTION_CANCEL, getSubscriptionCancleMain);
  yield takeEvery(START_SUBSCRIPTION_UPDATE, getSubscriptionUpdateMain);
}
